/**
 * QOE_PRICING_ENABLED — master switch for every fee / dollar-amount surface that
 * represents *what Yansar charges* (base fee, add-on fees, total engagement fee,
 * billing rows, revenue rollups).
 *
 * Default OFF. Baked at build time by Vite, so flipping it needs a rebuild:
 *   docker/ACR:  --build-arg "VITE_QOE_PRICING_ENABLED=true"
 *   local dev:   VITE_QOE_PRICING_ENABLED=true npm run dev
 *
 * NOT covered by this flag — these are the client's own numbers and stay visible:
 *   - scope tier (Focused QoE / MIR points) and engagement tier
 *   - deal financials: LOI / asking price, revenue, Adj. EBITDA, SDE, NWC
 */
export const PRICING_ENABLED =
  String(import.meta.env.VITE_QOE_PRICING_ENABLED ?? '').toLowerCase() === 'true'
